// @flow @jsx h
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable promise/catch-or-return */
/* eslint-disable promise/always-return */
import { Component, h } from 'preact'
import { bem } from '@nrk/dh-utils'
import TogglePlayButton from './TogglePlayButton'
import styles from './index.css'

type Caption = {
  in: number,
  newLine: boolean,
  text: string,
  name?: string
}

type Props = {
  mp3: string,
  captions: Caption[],
  onPlay: (position: number) => void,
  onStop: (position: number) => void
}

type State = {
  playing: boolean,
  progress: number
}

export default class VoiceText extends Component<Props, State> {
  sound: any
  interval: any
  state = {
    playing: false,
    progress: 0
  }

  componentDidMount () {
    this.createSound()
  }

  createSound () {
    require('../wrappers/howlerWrapper.js').getHowler()
      .then(({ Howl }) => {
        this.sound = new Howl({
          src: [this.props.mp3],
          onplay: this.handlePlay,
          onpause: this.handleStop,
          onstop: this.handleStop,
          onend: this.handleStop
        })
      })
  }

  handlePlay = () => {
    try {
      this.props.onPlay(this.sound.seek())
    } catch (e) {
      // Do nothing
    }
    this.setState({ playing: true })
    this.startProgress()
  }

  handleStop = () => {
    try {
      this.props.onStop(this.sound.seek())
    } catch (e) {
      // Do nothing
    }
    this.setState({ playing: false })
    this.stopProgress()
  }

  handleTogglePlay = (e: Event) => {
    e.stopPropagation()
    if (this.state.playing) {
      this.sound.pause()
    } else {
      this.sound.play()
    }
  }

  startProgress = () => {
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.setState({ progress: this.sound.seek() })
      }, 300)
    }
  }

  stopProgress = () => {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  render () {
    return <div onClick={this.handleTogglePlay}>
      <span class={bem(styles.voiceText, { active: this.state.progress > 0 })}>
        <TogglePlayButton playing={this.state.playing} onClick={this.handleTogglePlay} />
      </span>
      {this.props.captions.map((caption, idx) => {
        const active = this.state.progress > caption.in
        return [
          caption.newLine && <br />,
          <span key={idx} class={bem(styles.voiceText, { active })}>
            {caption.name && <span class={styles.voiceText__name}>{caption.name}: </span>}
            {caption.text}
          </span>
        ]
      })}
    </div>
  }
}
